<div class="health-container">
  <div *ngFor="let item of healthItems" class="health-item" (click)="navigateTo(item.route, item.title)">
    <div class="icon-container">
      <img [src]="item.icon" alt="" class="item-icon">
    </div>
    <div class="item-text">
      <div class="item-title">{{ item.title }}</div>
      <div class="item-description">{{ item.description }}</div>
    </div>
    <span class="arrow">></span>
  </div>
</div>